// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RO_5N","right":"styles_right__3C5Te"};